define([
    'jquery',
    'mage/translate',
    'mage/validation'
], function ($, __) {
    'use strict';

    $.validator.addMethod(
        'valid-option',
        (value, element, params) => !(value === null && element.selectedIndex),
        __('The selected option is not available.')
    );
});
